import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";

const getClient = {
    namespaced: true,
    state: {
        clientData: {},
        dataReceive: {}
    },
    mutations: {
        SUCCESS_GET_CLIENT(state, response) {
            state.dataReceive = response.data.data;
            if(!response.data.data.address_invoice) {
                state.dataReceive.address_invoice = {};
            }
            eventBus.$emit("getClientSuccess", response.data.data);
            eventBus.$emit("addClientStep", response.data.data);
            eventBus.$emit("addClientSelect", response.data.data);
            },
        ERROR_GET_CLIENT(state, error) {
            console.log(error);
        },
        SUCCESS_GET_LAST_ID(state, response) {
            eventBus.$emit("deleteLastClient", response.data);
        },
        FAILURE_GET_LAST_ID(state, error) {
            console.log(error);
        }
    },
    actions: {
        getClient({ dispatch }, payload = {}) {
            let url = new URL(window.location.href);
            let id = payload.creds !== undefined ? payload.creds.id :  url.searchParams.get("id");
            var promise = sendRequest("get", config.baseURLApi + "/clients/" + id, {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("getClientSuccess", result[1]);
                } else {
                    dispatch("getClientError", result[1]);
                }
            });
        },
        getClientSuccess({ commit }, response) {
            commit("SUCCESS_GET_CLIENT", response);
        },
        getClientError({ commit }, error) {
            commit("ERROR_GET_CLIENT", error);
        },
        getLastClientId({ dispatch }) {
            var promise = sendRequest("post", config.baseURLApi + "/clients/getIdLast");
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("getLastIdSuccess", result[1]);
                } else {
                    dispatch("getLastIdFailure", result[1]);
                }
            });
        },
        getLastIdSuccess: function({ commit }, response) {
            commit("SUCCESS_GET_LAST_ID", response);
        },
        getLastIdFailure: function({ commit }, error) {
            commit("FAILURE_GET_LAST_ID", error);
        }
    }
}

export default getClient;